import AccordionRow from 'shared/AccordionRow';

import { styles } from './styles';
import type { IAccordionTable } from './types';

const AccordionTable = ({
  data,
  keyAccessor,
  fixedCells,
  dynamicCells,
  actionCells,
  sx,
  accordionChildren,
  ...rest
}: IAccordionTable) => (
  <>
    {data.map((dataItem, index) => (
      <AccordionRow
        key={`accordion-row-${dataItem[keyAccessor]}`}
        data={dataItem}
        fixedCells={fixedCells}
        dynamicCells={dynamicCells}
        actionCells={actionCells}
        sx={[index % 2 === 0 ? styles.even : styles.odd, ...(Array.isArray(sx) ? sx : [sx])]}
        accordionChildren={accordionChildren}
        {...rest}
      />
    ))}
  </>
);

export default AccordionTable;
